/* eslint-disable react/jsx-key */
import * as Yup from 'yup';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Stack } from '@mui/material';
import { ItemTypesEnum } from 'src/@types/Course';
import { LoadingButton } from '@mui/lab';
import TextMaxLine from 'src/components/TextMaxLine';
import { FormProvider, RHFSelect } from 'src/components/hook-form';
// ----------------------------------------------------------------------

type dataType= {
    type:ItemTypesEnum 
}
export default function ItemTypeForm({ onSubmit }: { onSubmit(data: dataType): void }) {
  const ItemTypeSchema = Yup.object().shape({
    type: Yup.string().required('Item Type Required'),
  });
  const ItemTypeDefaultValue = useMemo(
    () => ({
      type: ItemTypesEnum.NEW,
    }),
    []
  );

  const methods = useForm<dataType>({
    resolver: yupResolver(ItemTypeSchema),
    defaultValues: ItemTypeDefaultValue,
  });
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack height={'100%'} justifyContent={'space-between'} p={1}>
        <Box>
          <TextMaxLine sx={{ marginBottom: '20px' }}>Select Section Item Type</TextMaxLine>
          <RHFSelect
            name="type"
          >
            <option key={'none'} value={''} disabled> Section Item Type</option>
            {Object.values(ItemTypesEnum).map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </RHFSelect>
        </Box>
        <Stack justifyContent={'flex-end'}>
          <LoadingButton
            style={{ width: '200px', height: '50px' }}
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            {'Next'}
          </LoadingButton>
        </Stack>
      </Stack>
    </FormProvider>
  );
}
